export class User {
    preferences : {[key : string] : any};
    legantoFeatures : {[key : string] : any};
    customerSettings : {[key : string] : any};
    [key : string] : any;
}
